import type { ShellLinkProps } from "@nymbl/nos2-rules";
import { Link } from "@tanstack/react-router";

/** The router's link for the shell and Metric cards. An `href` may carry a query string. */
export function ShellLink({ href, ...rest }: ShellLinkProps) {
  const [to, query] = href.split("?");
  if (!query) return <Link to={to} {...rest} />;
  return (
    <Link to={to} search={Object.fromEntries(new URLSearchParams(query)) as never} {...rest} />
  );
}
